module.exports = __webpack_public_path__ + "media/images/common/menu_coop_mie-8bf4dfb8e63b7adc3c9fd9a65c021dfb.png";